import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';

function OrgaoDepartamentoModal({ show, onClose, onSuccess, departamento, orgaoId }) {
  const [formData, setFormData] = useState({
    nome: '',
    responsavelCpf: '',
    situacao: 'ATIVO',
  });
  const [usuarios, setUsuarios] = useState([]);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show) {
      if (departamento) {
        setFormData({
          nome: departamento.nome || '',
          responsavelCpf: departamento.responsavelCpf || '',
          situacao: departamento.situacao || 'ATIVO',
        });
      } else {
        setFormData({
          nome: '',
          responsavelCpf: '',
          situacao: 'ATIVO',
        });
      }
    }
  }, [show, departamento]);

  useEffect(() => {
    if (show) {
      axios
        .get(`${API_BASE_URL.USUARIO}/all`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setUsuarios(res.data))
        .catch(() => setUsuarios([]));
    }
  }, [show, token]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value.toUpperCase() }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (!formData.nome) {
      showDefaultModal('error', 'Informe o nome do departamento!');
      return;
    }

    const payload = {
      ...formData,
      idOrgao: orgaoId,
      idDepartamento: departamento?.idDepartamento || null,
    };

    const request = departamento
      ? axios.put(`${API_BASE_URL.ORGAO_DEPARTAMENTO}/update`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      : axios.post(`${API_BASE_URL.ORGAO_DEPARTAMENTO}/save`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

    request
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch(error => {
        console.error('Erro ao salvar departamento:', error);
        showDefaultModal('error', 'Erro ao salvar o departamento!');
      });
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw', maxHeight: '80vh' }}>
          <div className="modal-content" style={{ maxHeight: '80vh', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                padding: '0.35rem 0.75rem',
              border: 'none',
              flexShrink: 0,
            }}
          >
              <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                <i className="bi bi-diagram-3 me-2"></i>
                {departamento ? 'Editar Departamento' : 'Novo Departamento'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Nome <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    placeholder="Ex: Secretaria de Saúde"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">Responsável</label>
                  <select
                    className="form-select form-select-sm"
                    name="responsavelCpf"
                    value={formData.responsavelCpf}
                    onChange={handleChange}
                  >
                    <option value="">Selecione...</option>
                    {usuarios.map(u => (
                      <option key={u.cpf} value={u.cpf}>
                        {u.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">Situação</label>
                  <select
                    className="form-select form-select-sm"
                    name="situacao"
                    value={formData.situacao}
                    onChange={handleChange}
                  >
                    <option value="ATIVO">ATIVO</option>
                    <option value="INATIVO">INATIVO</option>
                  </select>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                    <i className="bi bi-x-circle me-1"></i>Cancelar
                  </button>
                  <button type="submit" className="btn btn-success btn-sm">
                    <i className="bi bi-check-lg me-1"></i>Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default OrgaoDepartamentoModal;
